import { apiGet, apiPost } from '../services/apiClient';

export const getPaymentSettings = async (token) => apiGet('/api/admin/finance/settings', token);

export const savePaymentSettings = async (token, payload) =>
  apiPost('/api/admin/finance/settings', payload, token);
